import React from "react";

const InmateReport = ({ inmateReport }) => {
  return (
    <div>
      <table className="min-w-full overflow-y-visible bg-white  border-gray-200 rounded-md">
        {/* Table Head  */}
        <thead>
          <tr className="bg-gray-100 ">
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
              Sl No.
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Building Name
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              No. of Bookings
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-r-xl">
              No. of Check Ins
            </th>
          </tr>
        </thead>
        {/* Table Body  */}
        <tbody>
          {inmateReport?.length > 0 ? (
            inmateReport.map((data, index) => (
              <tr
                key={index}
                className="border-b border-gray-200 hover:bg-gray-50"
              >
                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {index + 1}
                </td>
                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {data.buildingName}
                </td>

                <td className="py-4 px-6 text-sm text-primaryTextColor">
                  {data.bookingsCount}
                </td>

                <td className="py-4 px-6 text-sm text-primaryTextColor">
                  {data.checkInsCount}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="4"
                className="py-40 px-6 text-lg text-center text-secondaryTextColor"
              >
                No Data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InmateReport;
